import React from "react";
import "./MasterConfiguration.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import Master from "../../../components/Masters/Masters";
import {
  SkeletonContainer,
  SkeletonDataTable,
} from "../../../components/Loader/Loader";
import { useMasterconfig } from "../../../Hooks/Features/MasterConfiguration/useMasterconfig";
import CommanDialog from "../../../components/CommonCompo/CommanDialog/CommanDialog";

function MasterConfiguration() {
  const {
    handleCreateMaster, loader, filteredMasters, handleColumnList, renameMaster, setshowDelete, isColDelete, showGrid, icons, handleComponent, masterComponent, handleMasterConfig, expandedGroups, toggleGroup, sideOpen, setSideOpen, searchQuery, setSearchQuery,
    currentVisibleMaster, columnDefs, rowData, gridRefs, isMasterCall, handleConfigComponent, showCreatePopup, onHide, tableNameOptions, isNewMaster, currentMaster, groupOptions, handleUpsertMaster, showDelete, deleteMaster, deleteColumn, currentData, listLoader, gridApiRef, onCellValueChanged, handleChange, tableData } = useMasterconfig();

  const Button = () => {
    return <div className="">
      {!masterComponent && showGrid && icons && (
        <button onClick={handleComponent}>CRUD</button>
      )}
      {masterComponent && (
        <button onClick={handleMasterConfig}>
          <FontAwesomeIcon icon="fa-solid fa-gear" />
        </button>
      )}
    </div>
  }
  return (
    <div>
      <div className='row'>
        <div className="col-md-6">
          <div>
            <input
              type="text"
              placeholder="Search here..."
              value={searchQuery}
              className="input-dd"
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
        <div className="col-md-6 text-right">
          <button onClick={handleCreateMaster}>
            <FontAwesomeIcon icon="fa-solid fa-plus" /> Table
          </button>
        </div>
      </div>
      <div className="main-master-container">
        <div className={`master-list-left ${sideOpen && "list-view"}`}>
          {
            sideOpen && <div style={{ height: "calc(100vh - 240px)" }}>
              {
                listLoader ? <SkeletonContainer /> : <div className='group-list'>
                  {Object.entries(filteredMasters).map(([groupName, items]) => (
                    <div>
                      <div className='group-name' onClick={() => toggleGroup(groupName)}>
                        <p>
                          {expandedGroups.includes(groupName) ? (
                            <FontAwesomeIcon icon="fa-solid fa-chevron-up" style={{ fontSize: "14px" }} />
                          ) : (
                            <FontAwesomeIcon icon="fa-solid fa-chevron-down" style={{ fontSize: "14px" }} />
                          )} {groupName}
                        </p>
                      </div>
                      <div className={`child-list${expandedGroups.includes(groupName) ? ' expanded' : ''}`}>
                        {expandedGroups.includes(groupName) &&
                          items.map((item) => (
                            <li
                              key={item.object_id}
                              className={`${currentVisibleMaster.display_name === item.display_name ? "master" : ""}`}
                              onClick={(e) => handleColumnList(item)}
                            >
                              {item.display_name}
                              <span style={{ float: "right" }}>
                                <span style={{ padding: "10px", cursor: "pointer" }}>
                                  <FontAwesomeIcon
                                    icon="fa-solid fa-pen"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      renameMaster(item)
                                    }}
                                  />
                                </span>
                                <span>
                                  <FontAwesomeIcon
                                    icon="fa-solid fa-trash"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setshowDelete(true);
                                      currentData.current = item;
                                      isColDelete.current = false;
                                    }}
                                  />
                                </span>
                              </span>
                            </li>
                          ))}
                      </div>
                    </div>

                  ))}
                </div>
              }

            </div>
          }
          <div
            className="broadcast-arrow-btn"
            onClick={() => setSideOpen(!sideOpen)}
          >
            <FontAwesomeIcon
              icon="fa-solid fa-angle-right"
              className="broadcast-svg"
            />
          </div>
        </div>
        {currentVisibleMaster && (
          <div className="master-list-right">
            {showGrid && (
              <div>
                <div className="d-flex justify-content-between">
                  <div>
                    <h4>{currentVisibleMaster.display_name} </h4>
                  </div>
                  <Button />
                </div>
                <h6>Total:{rowData.length}</h6>
                <div className="master-table">
                  <div>
                    <div className="ag-theme-alpine new-game-container  aggrid-container master-grid">
                      {loader ? (
                        <SkeletonDataTable numSkeletons={10} />
                      ) : (
                        <AgGridReact
                          columnDefs={columnDefs}
                          rowData={rowData}
                          ref={gridRefs}
                          rowHeight={24}
                          headerHeight={30}
                          onCellFocused={onCellValueChanged}
                          onGridReady={(params) => {
                            gridApiRef.current = params.api;
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div>
              {isMasterCall && (
                <div>
                  <Master
                    currentSelectedMaster={currentVisibleMaster}
                    handleConfig={handleConfigComponent}
                    Button={<Button />}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div>
        <Dialog
          draggable={false}
          visible={showCreatePopup}
          onHide={() => onHide()}
          style={{ width: "30%" }}
          className="master-create-popup"
          header="Create new master"
        >
          <div className="master-create-popup-content">
            {!isNewMaster && (
              <div className="w100">
                <div>Select Master:</div>
                <Dropdown
                  className="input-dd"
                  options={tableNameOptions}
                  optionLabel="name"
                  value={tableData.object_id}
                  onChange={handleChange}
                  name="object_id"
                  filter
                  filterInputAutoFocus
                  required
                />
              </div>
            )}
            {isNewMaster && <div className="w100 d-flex justify-content-between ">Master: <span>{currentMaster}</span></div>}
            <div className="w100">
              <div>Enter display name:</div>
              <input
                className="w100 input-dd"
                type="text"
                name="display_name"
                value={tableData.display_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="w100">
              <div>Enter description:</div>
              <textarea
                className="master-decrip-textarea"
                name="descriptions"
                rows={3}
                value={tableData.descriptions}
                onChange={handleChange}
              />
            </div>
            <div className="w100">
              <div>Select Group:</div>
              <Dropdown
                className="input-dd"
                options={groupOptions}
                value={tableData.entity_group_id}
                onChange={handleChange}
                optionLabel="group_name"
                filter
                filterInputAutoFocus
                required
                name="entity_group_id"
              />
            </div>
            <div>
              <input
                className="master-active-checkbox"
                type="checkbox"
                id="master-checkbox"
                checked={tableData?.is_active}
                onChange={(e) => handleChange(e, true)}
                name="is_active"
              />
              <label htmlFor="master-checkbox">Active</label>
            </div>
            <button onClick={handleUpsertMaster}>Save</button>
          </div>
        </Dialog>
        <CommanDialog
          visible={showDelete}
          message={"Are You Sure You Want to delete it?"}
          handleClose={() => setshowDelete(false)}
          handleFun={() => {
            setshowDelete(false);
            !isColDelete.current
              ? deleteMaster(currentData.current)
              : deleteColumn(currentData.current);
          }}
        />
      </div>
    </div>
  );
}

export default MasterConfiguration;
